<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <div class="client-page d-flex align-items-center gap-3 mb-4">
        <form [formGroup]="form" class="filters d-flex align-items-center gap-3 flex-wrap">
            <mat-form-field appearance="fill" class="filters-form-field">
                <mat-label>Client name</mat-label>
                <mat-icon matPrefix class="me-1">business</mat-icon>
                <input matInput formControlName="name" />
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="clientSubmit()">{{submitButton}}</button>
</mat-dialog-actions>
